/**
 * Navigation utilities for managing sidebar state during page transitions
 */

/**
 * Check if the sidebar should remain expanded after navigation
 * @returns true if sidebar should be collapsed, false if it should remain expanded
 */
export const checkSidebarNavigationState = (): boolean => {
  const isNavigating = sessionStorage.getItem('isNavigating')
  const navigationTime = sessionStorage.getItem('navigationTime')
  
  if (isNavigating === 'true' && navigationTime) {
    const timeDiff = Date.now() - parseInt(navigationTime)
    // If navigation happened within last 2 seconds, keep sidebar expanded
    if (timeDiff < 2000) {
      // Clear the flag but keep sidebar expanded
      sessionStorage.removeItem('isNavigating')
      sessionStorage.removeItem('navigationTime')
      return false // Don't collapse - keep expanded after navigation
    }
  }
  
  // Clear any stale navigation state
  sessionStorage.removeItem('isNavigating')
  sessionStorage.removeItem('navigationTime')
  
  return true // Collapse by default for fresh page loads
}